// extracted by mini-css-extract-plugin
export default {"cls1":"LHqraVnuldTcQhMCZdNb","cls2":"zhrLOpsCkcRNmj7JtPUw LHqraVnuldTcQhMCZdNb"};